import React from 'react';
import { connect } from 'react-redux';
import { contains, pathOr } from 'ramda';
import { updateDeveloperName } from '../../actions/reduxActions/currentTenant';
import translations from '../../translations';
import { REGEX_ILLEGAL_TENANT_NAME } from '../../constants';

const DeveloperName = ({ developerName, updateDeveloperName }) => {
    const isSubtenant = contains('+', developerName);

    // Remove the @ prefix, and split into subtenant name and parent tenant name (which could be blank for parents)
    const [tenantDeveloperName, parentTenantName] = developerName.substring(1).split('+');

    const subtenantNameAddon = isSubtenant
        ? <span className="input-group-addon">+{ parentTenantName }</span>
        : null;

    const createAndUpdateFullDeveloperName = (value) => {
        // Strip any disallowed characters
        value = value.replace(REGEX_ILLEGAL_TENANT_NAME, '');

        const name = isSubtenant
            ? `@${ value }+${ parentTenantName }`
            : `@${ value }`;

        updateDeveloperName(name);
    };

    let subtenantSpiel;
    if (!isSubtenant) {
        subtenantSpiel = (
            <span>{ translations['tenant renaming subtenant warning'] }</span>
        );
    }

    return (
        <React.Fragment>
            <div className="form-group">
                <div className="input-group developer-name">
                    <span className="input-group-addon">@</span>
                    <input
                        className="form-control"
                        maxLength="48"
                        value={ tenantDeveloperName }
                        onChange={ ({ target }) => createAndUpdateFullDeveloperName(target.value) }
                    />
                    { subtenantNameAddon }
                </div>

                <span className="help-block">
                    { translations['tenant renaming help text'] } { subtenantSpiel }
                </span>
            </div>
        </React.Fragment>
    );
};

export const mapStateToProps = ({ currentTenant }) => ({
    developerName: pathOr('', ['developerName'], currentTenant),
});

const mapDispatchToProps = {
    updateDeveloperName,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DeveloperName);
